import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wraps children with auth guard.
 * @param {{ adminOnly?: boolean, children: React.ReactNode }} props
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="w-8 h-8 rounded-full border-4 border-brand border-t-transparent animate-spin" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (adminOnly) {
        const isFullAdmin = user?.role === 'admin' || user?.is_superadmin;
        const su = user?.is_superadmin;

        // Gantt — faqat aniq gantt ruxsatlari (isFullAdmin shart emas)
        const isGanttAdmin = su ||
            user?.can_manage_gantt || user?.can_view_gantt || user?.can_create_gantt ||
            user?.can_edit_gantt || user?.can_delete_gantt || user?.role === 'gantt_user';

        // Docs — faqat aniq docs ruxsatlari (isFullAdmin shart emas)
        const isDocsAdmin = su ||
            user?.can_view_documents || user?.can_create_documents || user?.can_edit_documents ||
            user?.can_delete_documents || user?.can_manage_doc_approvers || user?.can_import_doc_files ||
            user?.can_unlock_documents || user?.role === 'doc_user';

        const canSeeUsers = isFullAdmin || user?.can_create_users || user?.can_delete_users;
        const canSeeCategories = isFullAdmin ||
            user?.can_create_categories || user?.can_edit_categories || user?.can_delete_categories ||
            user?.can_edit_category_order;

        const canSeeOrganizations = su || user?.can_manage_organizations;

        const hasAnyAdminAccess = isGanttAdmin || isDocsAdmin || canSeeUsers || canSeeCategories || canSeeOrganizations;

        const path = location.pathname;

        // Hech qanday admin ruxsati yo'q — panel ga qaytarish
        if (!hasAnyAdminAccess) {
            return <Navigate to="/panel" replace />;
        }

        // /admin yoki /admin/ ga kirgan paytda to'g'ri yo'nalish
        if (path === '/admin' || path === '/admin/') {
            if (isFullAdmin || canSeeUsers) return <Navigate to="/admin/users" replace />;
            if (canSeeOrganizations) return <Navigate to="/admin/organizations" replace />;
            if (isGanttAdmin) return <Navigate to="/admin/gantt" replace />;
            if (isDocsAdmin) return <Navigate to="/admin/docs" replace />;
        }
    }

    return children;
}
